// Include polyfills
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// Continue with normal setup
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Import imported SBK web components and their styles
import manifest from './imported/sbk/.vite/manifest.json';

for (const file of Object.values(manifest)) {
    if (file.name !== 'ogs') {
        // eslint-disable-next-line import/no-dynamic-require, global-require
        require(`./imported/sbk/${file.file}`);

        for (const style of file.css || []) {
            // eslint-disable-next-line import/no-dynamic-require, global-require
            require(`./imported/sbk/${style}`);
        }
    }
}

const root = createRoot(document.getElementById('root'));
root.render(
    <StrictMode>
        <App />
    </StrictMode>,
);
